import { render, staticRenderFns } from "./TheDefaultHeader.vue?vue&type=template&id=f683f970&"
import script from "./TheDefaultHeader.vue?vue&type=script&lang=js&"
export * from "./TheDefaultHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports